export default __webpack_public_path__ + "static/media/small-park.d96eaa0e.svg";